import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useUpdateLcrWorksheet = (crId, lcrId, worksheetId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    (payload) => axiosInstance.put(liveCleanroom(orgId)
      .updateLcrWorksheet(crId, lcrId, worksheetId), payload),
    {
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error updating LCR worksheet',
            type: 'error',
          }),
        );
      },
    },
  );
};
